interface PopularAddonsHeaderProps {
  title: string;
  description: string;
}

export function PopularAddonsHeader({
  title,
  description
}: PopularAddonsHeaderProps) {
  return (
    <div
      id="configurator-header"
      className="flex flex-col items-center gap-2 self-center"
    >
      <p className="text-dark-gray text-xl font-semibold">{title}</p>
      <p className="text-muted-text text-center text-sm font-normal">
        {description}
      </p>
    </div>
  );
}
